import animateScrollUp from './modules/scroll_up';

$(() => {
  const listingForm = $('#listing-form-with-dropzone');

  $('.edit-previous-step').on('click', function () {
    $('.nav a[href*="profile"]').click();
  });

  let imagesPresent = function () {
    return (listingForm.data('required') ? $('.dropzone-previews .dz-preview').length > 0 : true);
  };

  let checkPriceInput = function (input) {
    if (!$(input).length) {
      return true;
    }
    let priceInput, price, errorSpan, minPrice, priceDiv, discountPrice;
    priceInput = $(input);
    price = priceInput.val().replace(/[ ,]/, '');
    minPrice = priceInput.data('autonumeric').minVal;
    discountPrice = priceInput.data('autonumeric').discountPrice;
    priceDiv = $('.listing_price');

    if (price === '') {
      priceInput.nextAll('.customErrorText').remove();
      errorSpan = '<span class="customErrorText">' + I18n.t('cant_be_blank') + '</span>';
      priceInput.after(errorSpan);
      priceDiv.find($('.errorText')).remove();
      priceInput.parent().addClass('custom_field_with_errors field_with_errors');
      return false;
    } else if (discountPrice && price <= discountPrice) {
      priceInput.nextAll('.customErrorText').remove();
      errorSpan = '<span class="customErrorText">' + I18n.t('greater_than_discount', {
        price: discountPrice
      }) + '</span>';
      priceInput.after(errorSpan);
      priceDiv.find($('.errorText')).remove();
      priceInput.parent().addClass('custom_field_with_errors field_with_errors');
      return false;
    } else if (price < minPrice) {
      priceInput.nextAll('.customErrorText').remove();
      errorSpan = '<span class="customErrorText">' + I18n.t('greater', {
        price: minPrice
      }) + '</span>';
      priceInput.after(errorSpan);
      priceDiv.find($('.errorText')).remove();
      priceInput.parent().addClass('custom_field_with_errors field_with_errors');
      return false;
    }
    priceInput.nextAll('.customErrorText').remove();
    priceInput.parent().removeClass('custom_field_with_errors field_with_errors');
    return true;
  };

  $('input.email').on('change', function () {
    $(this).parent().find('> span.errorText').remove();
  });

  $('#price-input').on('change', function () {
    checkPriceInput(this);
  });

  $('#listing-next-step, #listing-contact-link, #submit-with-dz').on('click', function () {
    listingForm.parsley().validate('details-about-car');

    let valid = listingForm.parsley().isValid('details-about-car');
    let priceInputValid = checkPriceInput($('#price-input'));
    let isFirstStepValid = priceInputValid && valid && imagesPresent();

    if (isFirstStepValid) {
      $(".nav[role='tablist'] a:last").tab('show');
      animateScrollUp();
    } else {
      if (!$('.dropzone-previews .dz-preview ').length) {
        $('.dz-message').css('border-color', '#f81300');
      }

      if ($('.field_with_errors').length) {

        let scrollTop = window.innerWidth > 576 ? 450 : 150;

        $('html, body').animate({
          scrollTop: $('.field_with_errors:first').offset().top - scrollTop
        }, 5000);
      }
    }
    return isFirstStepValid;
  });

  // Details about new car
  let letterLimit = 5000;
  let letterValue = $('#quantity-letters-size');
  let aimLimit = $('#listing-description');
  let sortable_aim = $('#sortable');

  sortable_aim.sortable();
  sortable_aim.disableSelection();

  if (letterValue.length) {
    letterValue.text(letterLimit - aimLimit.val().length);
  }

  aimLimit.bind('input propertychange', function () {
    letterValue.text(letterLimit - $(this).val().length);
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/processing_ad_form.js